import { html } from 'lit';
import '../notification-view';
const animationOptions = {
    duration: 500,
    easing: 'cubic-bezier(.2, .8, .2, 1)',
};
export class NotificationAnimationMapBaseController {
    constructor(element) {
        this.element = element;
        this.direction = 'vertical';
        this.vertical = 'notification-item';
        this.renderElements = null;
        this.removeElementsClientHeight = null;
        this.moveElements = null;
        this.animationOptions = animationOptions;
    }
    onKeyExtractor([id, record]) {
        if (id === 'fullView') {
            return 'item-' + id;
        }
        const date = new Date(record.timestamp);
        return 'item-' + id + `_${[date.getMinutes(), date.getSeconds()].join('-')}`;
    }
    onTemplateBuilder([id, record]) {
        if (id === 'fullView') {
            return html `
        <inch-button
          @click="${() => this.element.openAll()}"
          class="show-all-button"
          fullSize
          size="l"
          type="secondary"
        >
          <inch-icon icon="arrowDown24"></inch-icon>
        </inch-button>
      `;
        }
        return html `
      <inch-notification-view
        timestamp="${record.timestamp}"
        .config="${record.config}"
        @closeNotification="${() => this.element.closeNotification(id)}"
      >
        ${this.element.makeNotificationTemplate(record)}
      </inch-notification-view>
    `;
    }
    onAnimationStart() {
        this.element.animationStartHandler();
    }
    onAnimationComplete() {
        this.element.animationCompleteHandler();
    }
    async onBeforeAnimation(container, renderElements, removeElements, moveElements) {
        this.renderElements = renderElements;
        this.removeElementsClientHeight = new Map();
        removeElements.forEach((element, index) => {
            this.removeElementsClientHeight.set(index, element.clientHeight);
        });
        this.moveElements = moveElements;
    }
    async onAfterAnimation() {
        this.renderElements = null;
        this.removeElementsClientHeight = null;
        this.moveElements = null;
    }
    async onAfterRenderAnimateItem(element, index) {
        const reset = () => {
            this.onAfterRenderAnimateItemSkipTransition(element, index);
        };
        if (this.element.scrollTop >= this.topOffset) {
            reset();
            return;
        }
        const rect = element.getBoundingClientRect();
        if (rect.top + rect.height - this.topOffset > window.innerHeight) {
            reset();
            return;
        }
        await this.onAfterRenderAnimateItemTransition(element, index);
        reset();
    }
    async onBeforeMoveAnimationItem(element, oldIndex, newIndex) {
        return newIndex;
    }
    getOffsetByIndex(index) {
        let offset = null;
        this.moveElements?.forEach((element, [oldIndex, newIndex]) => {
            if (index - 1 === newIndex) {
                offset = element.clientHeight * (oldIndex > newIndex ? -1 : 1);
            }
        });
        if (offset === null && this.removeElementsClientHeight) {
            const newNode = this.renderElements?.get(0);
            offset = newNode?.clientHeight ?? null;
        }
        if (offset === null && this.removeElementsClientHeight) {
            this.removeElementsClientHeight.forEach((clientHeight, removeIndex) => {
                if (removeIndex === index) {
                    offset = clientHeight * -1;
                }
            });
        }
        return offset ?? 0;
    }
}
//# sourceMappingURL=notification-animation-map-base-controller.js.map